module.exports = __webpack_public_path__ + "img/coupon_a.3fcba233.png";